module.exports = __webpack_public_path__ + "img/info-img.d033914e.svg";